import { KTIcon } from "../../../../_metronic/helpers";

const ApprovalModalHeader = ({
  setOpenApprovalModal,
  selectedItem,
  setSelectedItem
}) => {
  return (
    <div className="modal-header">
      {/* begin::Modal title */}
      <div>
      <h2 className="fw-bolder">{`${selectedItem?.listing_name}`}</h2>
      </div>
      {/* end::Modal title */}

      {/* begin::Close */}
      <div
        className="btn btn-icon btn-sm btn-active-icon-primary"
        data-kt-users-modal-action="close"
        onClick={() => {
          setSelectedItem(null)
          setOpenApprovalModal(false);
        }}
        style={{ cursor: "pointer" }}
      >
        <KTIcon iconName="cross" className="fs-1" />
      </div>
      {/* end::Close */}
    </div>
  );
};

export { ApprovalModalHeader };
